import React, { Component } from "react";
import "./KtbstRiskQuestion.css";
import { fieldset, Radio } from "react-custom-radio";
import ButtonCustom from "../../components/button/ButtonCustom";
import axios from "axios";
import { set } from "date-fns";
import Loading from "../../components/loading/loading";
import {
  checkEditPage,
  checkInternet,
  popupNetworkLost,
  download_ico_alert,
  popupError,
  popupErrorApi,
} from "../../components/helpers/Helpers";
import { config } from "./../../constants";
import { isMobile } from "react-device-detect";
import BannerContentLeft from "../../components/BannerContentLeft/BannerContentLeft";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
const MySwal = withReactContent(Swal);
const _url = config.baseAPIURL03;
class KtbstRiskQuestion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      listChooce: [],
      status_btn: false,
      // chkboxs: [
      //     {id: 1, text: "เงินฝากธนาคาร",value:'1', isChecked: false},
      //     {id: 2, text: "พันธบัตรรัฐบาล หรือกองทุนรวม พันธบัตรรัฐบาล",value:'2', isChecked: false},
      //     {id: 3, text: "หุ้นกู้ หรือกองทุนรวมตราสารหนี้",value:'3', isChecked: false},
      //     {id: 4, text: "หุ้นสามัญ หรือ กองทุนรวมหุ้น หรือ สินทรัพย์อื่นที่มีความเสี่ยงสูง",value:'4', isChecked: false}
      //   ],
    };

    this.goBack = this.goBack.bind(this);
  }
  boldText = (e) => {
    if (e.target.checked) {
      e.target.parentNode.style.fontWeight = "500";
    } else {
      e.target.parentNode.style.fontWeight = "300";
    }
    this.buildSuitabilityData();
  };
  async componentDidMount() {
    this.setState({ loading: true });
    // await download_ico_alert();
    var dataAnwser = await JSON.parse(localStorage.getItem("question"));
    const HeaderManp = await JSON.parse(localStorage.getItem("HeaderManp"));
    var head_token = HeaderManp.head_token;
    // var head_token = "IQcw6lmY5M+q9dnt9GzOjMBv9ejg5rP0xD3dm911Y/U=";
    await axios
      .get(_url + `/form/suitability/selbyhead?head_token=${head_token}`)
      .then((res) => {
        this.setState({ loading: false });
        this.setState({ listChooce: res.data.Data[1] });
        let chooceByDefault = res.data.Data[1];
        for (var i = 0; i < chooceByDefault.length; i++) {
          var d = dataAnwser.find((a) => {
            return a.SAmsa_Id === chooceByDefault[i].SAmsa_Id;
          });
          if (d) {
            chooceByDefault[i].SAfsac_Answer = d.SAfsac_Answer;
          }
          //console.log(chooceByDefault[i]);
        }

        var oldValue = JSON.parse(localStorage.getItem("RiskQuestion"));
        // console.log(oldValue)
        if (oldValue != undefined) {
          for (var i = 0; i < chooceByDefault.length; i++) {
            var d = oldValue.suit_json.find((a) => {
              return a.SAfsac_SAmsa_Id == chooceByDefault[i].SAmsa_Id + "";
            });
            if (d) {
              chooceByDefault[i].SAfsac_Answer = d.SAfsac_Answer;
            }

            //console.log(chooceByDefault[i]);
          }
        }
        var btn_submit = true;
        // console.log(this.state.listChooce);
        for (let i_ = 0; i_ < this.state.listChooce.length; i_++) {
          if (
            i_ < 10 &&
            this.state.listChooce[i_].SAmsa_IsMultiChoice === 1 &&
            this.state.listChooce[i_].SAfsac_Answer === ""
          ) {
            btn_submit = false;
            break;
          }
        }
        this.setState({ status_btn: btn_submit });
        const chooce = res.data.Data[1].map((item, i) => {
          if (i >= 0 && i <= 9) {
            let arr = JSON.parse(item.SAmsa_Answer);
            return (
              <div className="content_risk_question" key={i + "topic"}>
                <input
                  type="hidden"
                  name="SAfsac_SAmsa_Id[]"
                  value={item.SAmsa_Id}
                />
                <div
                  className="title_quest"
                  id={"q_" + (i + 1)}
                  dangerouslySetInnerHTML={{ __html: item.SAmsa_Question }}
                />
                <div className={"q_" + (i + 1)}>
                  {arr.map((itemSub, iSub) => {
                    return item.SAmsa_IsMultiChoice == 0 ? (
                      <div className="flex_radio" key={i + "_" + iSub}>
                        <input
                          type="radio"
                          required
                          value={itemSub.ChoiceID}
                          defaultChecked={
                            item.SAfsac_Answer == null
                              ? ""
                              : item.SAfsac_Answer == itemSub.ChoiceID
                          }
                          className="radio_question"
                          id={"radio_" + item.SAmsa_Id + iSub}
                          data-question={item.SAmsa_Id}
                          name={`SAfsac_Answer_radio_${item.SAmsa_Id}`}
                        />
                        <label
                          htmlFor={"radio_" + item.SAmsa_Id + iSub}
                          className="text_checkmark"
                        >
                          {itemSub.Text}
                        </label>
                      </div>
                    ) : item.SAmsa_IsMultiChoice == 1 ? (
                      <div key={i + "_" + iSub}>
                        <label className="container_none_border">
                          <input
                            type="checkbox"
                            id={"checkbox_" + item.SAmsa_Id + iSub}
                            required
                            value={itemSub.ChoiceID}
                            onChange={this.boldText}
                            defaultChecked={
                              item.SAfsac_Answer == null
                                ? ""
                                : item.SAfsac_Answer.split("_").includes(
                                    itemSub.ChoiceID + ""
                                  )
                            }
                            data-question={item.SAmsa_Id}
                            name={`SAfsac_Answer_checkbox_${item.SAmsa_Id}`}
                          />
                          <span className="text_checkmark">{itemSub.Text}</span>
                          <span className="checkmark"></span>
                        </label>
                      </div>
                    ) : (
                      ""
                    );
                  })}
                </div>
              </div>
            );
          }
        });
        this.setState({ chooces: chooce });

        //console.log(this.state.listChooce);
      })
      .catch(async (error) => {
        var mss = "";
        var title_mss = "";
        if (!!error.isAxiosError && !error.response) {
          title_mss = "เกิดข้อผิดพลาด";
          mss = "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง";
        } else {
          if (!!error.isAxiosError && !error.response) {
            title_mss = "เกิดข้อผิดพลาด";
            mss = "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง";
          } else {
            title_mss =
              error.response.data.Data[0][0].MsgDescTitle !== ""
                ? error.response.data.Data[0][0].MsgDescTitle
                : "เกิดข้อผิดพลาด";
            mss =
              error.response.data.Data[0][0].MsgDesc !== ""
                ? error.response.data.Data[0][0].MsgDesc
                : "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง";
          }
        }
        this.setState({ loading: false });
        popupErrorApi(
          mss,
          title_mss,
          true
          // function name() {
          //   var myStyle = document.getElementsByClassName("main_popup_loading")[0].style.display;
          //   if(myStyle === 'none'){
          //     document.getElementsByClassName("main_popup_loading")[0].style.display = 'block';
          //   }
          //   window.location = "login";
          // }
        );
      });
    //console.log(JSON.parse(localStorage.getItem('question')))
  }

  goBack() {
    localStorage.removeItem("RiskQuestion");
    this.props.history.push("/risk");
  }
 /* ดึง/แปลงข้อมูลจาก form เป็น mainData โดยไม่ส่ง API */
buildSuitabilityData = () => {
  const formData = new FormData(document.querySelector("form"));
  const chooces = this.state.listChooce;
  const data = {};

  for (const [key, value] of formData.entries()) {
    if (key === "SAfsac_SAmsa_Id[]") {
      data[value] = data[value] ?? {};
      data[value]["SAfsac_SAmsa_Id"] = value;

      const matched = chooces.find((d) => `${d.SAmsa_Id}` === `${value}`);
      if (matched) {
        data[value]["SAfsac_Id"] = `${matched.SAfsac_Id}`;
        data[value]["SAfsac_SubId"] = "";
        data[value]["SAfsac_SubAnswer"] = "";
        data[value]["SAfsac_Remark"] = "";
        data[value]["SAfsac_Remark2"] = "";
        data[value]["SAfsac_Delflag"] = 0;
      }
      continue;
    }

    if (key.startsWith("SAfsac_Answer")) {
      const ele = key.split("_");
      if (ele.length === 4) {
        const [, , type, questionId] = ele;
        data[questionId] = data[questionId] ?? {};

        if (type === "checkbox") {
          data[questionId]["SAfsac_Answer"] =
            (data[questionId]["SAfsac_Answer"] ?? "") + `${value}_`;
        } else if (type === "radio") {
          data[questionId]["SAfsac_Answer"] = value;
        }
        data[questionId]["SAfsac_Score"] = value;
      }
    }
  }

  const HeaderManp = JSON.parse(localStorage.getItem("HeaderManp"));
  const head_token = HeaderManp.head_token;
  const jsonData = Object.values(data);

  /* เช็คว่าตอบครบ 10 ข้อแรก */
  const btn_submit = !jsonData
    .slice(0, 10)
    .some(
      (item) => item.SAfsac_Answer === undefined || item.SAfsac_Answer === "",
    );
  this.setState({ status_btn: btn_submit });

  const totalScore = jsonData.reduce(
    (sum, item) => sum + (parseInt(item.SAfsac_Score) || 0),
    0,
  );

  const mainData = {
    head_token,
    TotalScore: totalScore,
    suit_json: jsonData,
  };

  localStorage.setItem("scoreAll", totalScore);
  localStorage.setItem("RiskQuestion", JSON.stringify(mainData));

  return mainData;
};

  /* เตรียม payload สำหรับส่ง API (ตัด TotalScore, เพิ่ม answerjson14, ตัด suit_json ถ้าเกิน 12) */
  buildSubmitPayload = (mainData) => {
    const payload = { ...mainData };
    delete payload.TotalScore;
    payload.answerjson14 = [];

    if (payload.suit_json.length > 12) {
      payload.suit_json = payload.suit_json.slice(0, -1);
    }

    return payload;
  };

  /* ส่งข้อมูลไป API */
  submitSuitability = (payload) => {
    axios
      .post(_url + "/form/suitability/manp", payload)
      .then((res) => {
        const message = res?.data?.Data?.[2]?.[0] || {};

        if (!message.MsgDesc) {
          this.props.history.push("/risk_poll");
          return;
        }

        MySwal.fire({
          imageUrl: "/images/ico_alert.svg",
          imageWidth: 100,
          imageHeight: 100,
          customClass: { confirmButton: "long_btn_fix" },
          allowOutsideClick: false,
          showConfirmButton: true,
          confirmButtonColor: "#003b66",
          confirmButtonText: "ประเมินใหม่",
          title: `<div class="title_popup">${message.MsgDescTitle}</div>`,
          html: `<div class="content_popup">${message.MsgDesc}</div>`,
        }).then(() => {
          [
            "is_recheck_risk",
            "is_recheck_risk_MsgDesc",
            "is_recheck_risk_MsgDescTitle",
            "question",
            "RiskQuestion",
            "scoreAll",
            "listQ14",
            "RiskQuestionPoll",
            "summary_risk",
          ].forEach((key) => localStorage.removeItem(key));
          this.setState({ loading: false });
          this.props.history.push("/risk");
        });
      })
      .catch(() => {
        this.setState({ loading: false });
        this.popupErrorApi(
          "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง",
          "เกิดข้อผิดพลาด",
        );
      });
  };

  handleSubmit = () => {
    this.setState({ loading: true });
    const mainData = this.buildSuitabilityData();
    const payload = this.buildSubmitPayload(mainData);
    this.submitSuitability(payload);
  };
  render() {
    const chooces = this.state.chooces;
    return (
      <div className={isMobile ? "" : "body"}>
        <header
          className={isMobile ? "" : "header-area"}
          style={{ display: isMobile ? "none" : "block" }}
        >
          <div className={"container everest-nav-container"}>
            <div className={"row"}>
              <div className={"col-md-6"}>
                <img src="../../../images/logo.png" alt="Logo" />
              </div>
              <div className={"col-md-6 flex_end"}>
                <div className="text-branding">บริการเปิดบัญชีออนไลน์</div>
              </div>
            </div>
          </div>
        </header>
        <section
          className={isMobile ? "" : "desktop_content section-gap-full"}
          style={{
            backgroundImage: isMobile ? "none" : "url(/images/bg.jpg)",
          }}
        >
          <div className={isMobile ? "" : "container"}>
            <div className={isMobile ? "" : "row"}>
              <div
                className={"col-md-6"}
                style={{ display: isMobile ? "none" : "block" }}
              >
                <BannerContentLeft></BannerContentLeft>
              </div>
              <div className={isMobile ? "" : "col-md-6"}>
                {/* content mobile */}
                <div>
                  <div className="content">
                    <div className="top_main_back">
                      <div className="main_back" onClick={this.goBack}>
                        <img
                          src={
                            isMobile
                              ? "/images/angle-arrow-left.svg"
                              : "/images/angle-arrow-left-blue.svg"
                          }
                          style={{ marginLeft: "3px" }}
                          className="arrow_back"
                          alt="Back"
                        />
                      </div>
                      <div className="text_title">
                        แบบประเมินความเหมาะสมในการลงทุน
                      </div>
                    </div>

                    <div className="bg_content_white">
                      <div className="title_quest">
                        คำถามข้อ 1-10
                        ใช้เพื่อประเมินความเหมาะสมในการลงทุนของท่าน
                      </div>
                      <div
                        style={{
                          color: "#ef534f",
                          fontSize: 24,
                          marginBottom: 24,
                          fontWeight: "normal",
                        }}
                      >
                        กรุณาทำแบบประเมินความเสี่ยง
                        เพื่อทำความรู้จักและเข้าใจรูปแบบการลงทุนที่เหมาะสมกับตัวคุณเองมากที่สุด
                        ทั้งนี้ คุณสามารถเปลี่ยนคำตอบได้
                        โดยระบบจะทำการคำนวณคะแนนให้ใหม่
                      </div>
                      <form>{chooces}</form>

                      <ButtonCustom
                        handle={
                          this.state.status_btn ? this.handleSubmit : null
                        }
                        label="ถัดไป"
                        color={this.state.status_btn ? "blue" : "gray"}
                        btnClass="long_btn"
                      ></ButtonCustom>
                    </div>
                  </div>
                  <Loading status={this.state.loading} />
                </div>
                {/* end content mobile */}
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default KtbstRiskQuestion;
